export default function Go_Packages_Modules () {
  return (
    <div>
      <h1>Go_Packages_Modules </h1>
      <p>Go Packages & Modules</p>
    </div>
  );
}